import { Box, styled } from '@mui/material'

export const SidebarHighlightCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  background: `linear-gradient(275deg, ${theme.palette.secondary.main} -30%, ${theme.palette.primary.light} 100%)`,
  color: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))
